































































































import Vue from "vue";
import Component from "vue-class-component";
import SocialM from "../../components/admin/SocialM.vue";
import { SocialMedia as SMInterface } from "../../services/social-media/entities/social-media.interface";
import CreateSocialMediaDialog from "../../components/admin/CreateSocialMediaDialog.vue";
import privileges from "../../utils/privileges";
import constants from "../../config/constants";

@Component({
  components: {
    SocialM,
    CreateSocialMediaDialog
  }
})
export default class SocialMedia extends Vue {
  loadingSocialMedia = false;
  dialogCreate = false;
  snackbarErrorDelete = false;
  snackbarSuccessDelete = false;
  privilegeName = constants.PRIVILEGE_NAME;
  privilegeType = constants.PRIVILEGE_TYPE;
  componentKey = 1;

  private checkPrivilege(name: string, type: string): boolean {
    return privileges.checkPrivilege(name, type);
  }

  private created(): void {
    this.loadingSocialMedia = true;
    this.$store.dispatch("socialMedia/getSocialMedia").finally(() => {
      this.loadingSocialMedia = false;
    });
  }

  private openDialogCreate(): void {
    this.dialogCreate = true;
    this.componentKey++;
  }

  private get socialMedia(): Array<SMInterface> {
    return this.$store.getters["socialMedia/getSocialMedia"];
  }
}
